import React from "react";
import "../style/work.css";
import Contact from "./Contact";

/**
 * Edit the data below — the layout renders itself.
 */
const EXPERIENCE = [
    {
        role: "Software Engineer | ERP Engineer",
        org: "Blue Technology Co., Ltd.",
        period: "Current",
        description:
            "Lead projects end-to-end as project leader while supporting the wider team, owning system architecture and project structure design across the stack. Build applications for Android, Cross Platform, Window Application, and Web System, Design Databases, Manage Deployment, and contribute business concepts that shape product direction.",
        highlights: [
            "Team Support",
            "System Architecture",
            "Android",
            "Cross Platform",
            "Desktop",
            "Web System",
            "Database Design",
            "Deployment",
            "Business Concept",
        ],
    },
    {
        role: "Programming Instructor",
        org: "ETEC Center",
        period: "2 years",
        description:
            "Taught programming fundamentals and guided students through hands-on projects.",
    },
];

const Work = () => {
    return (
        <section className="work content-width" id="work">
            <div className="work-title">
                <p className="work-eyebrow">Career</p>
                <h1>Work &amp; Experience</h1>
            </div>

            <div className="work-list">
                {EXPERIENCE.map((job) => (
                    <div className="work-card" key={job.role}>
                        <div className="work-card-top">
                            <h2>{job.role}</h2>
                            <span className="work-period">{job.period}</span>
                        </div>
                        <p className="work-org">{job.org}</p>
                        <p className="work-desc">{job.description}</p>
                        {job.highlights && (
                            <div className="work-tags">
                                {job.highlights.map((tag) => (
                                    <span className="work-tag" key={tag}>
                                        {tag}
                                    </span>
                                ))}
                            </div>
                        )}
                    </div>
                ))}
            </div>

            <Contact />
        </section>
    );
};

export default Work;